import styled from 'styled-components';

export const Content = styled.div<{ overflow?: string }>`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 30px;

  @media (max-width: 767px) {
    padding: 48px 16px 16px;
  }

  ${(props) =>
    props.overflow !== 'visible'
      ? `
    min-height: 0;
    overflow-x: hidden;
    overflow-y: auto;
  `
      : ''};
`;
